import api from "@/api";
import _ from "lodash";

export default {
    namespaced: true,

    actions: {
        async addLead(context, body) {
            const prefix = context.rootState.auth.accessToken ? 'v1' : 'anon'
            let url = `/api/${prefix}/airleads`
            let formData = new FormData();
            formData.append('question_guid', body.question_guid);
            formData.append('creator_guid', body.creator_guid);
            formData.append('type', body.type);
            formData.append('data', JSON.stringify(body.data));
            formData.append('location[lat]', body.location.lat);
            formData.append('location[lng]', body.location.lng);
            formData.append('location[accuracy]', body.location.accuracy);
            formData.append('notes', body.notes);
            formData.append('audio', body.audio);
            for (var i = 0; body.images.length > i; i++) {
                formData.append('file[]', body.images[i]);
            }
            try {
                const response = await api.request("post", url, formData);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async getInitialData(context, guid) {
            const prefix = context.rootState.auth.accessToken ? 'v1' : 'anon'
            
            const url = `/api/${prefix}/airleads/initialData?q_guid=${guid}`
            const response = await api.request("get", url);
            return response
        },
        async getAirLeads(context, item) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/api/v1/organizations/${guid}/airleads?page=${item.page}&fetch_all=${item.fetch_all}&hide_closed=${item.hide_closed}`
            const response = await api.request("get", url);
            return response.data
        },
        async saveAirLead(context, {airlead_guid, data}) {
            console.log(airlead_guid)
            console.log(data)
            const url = `/api/v1/airleads/${airlead_guid}`
            const response = await api.request("put", url, data)
            return response.data
        } 
    }
}